function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import Service from '@ember/service';
import { jsonPost } from '@square/dashboard-utilities/utils/xhr';
import { SearchDeviceCodesFilter, SearchDeviceCodesQuery, SearchDeviceCodesRequest, SearchDeviceCodesResponse } from '@square/dashboard-protos/models/squareup/devicesettings/external/device_code_search';
import { GetDeviceCodeRequest, GetDeviceCodeResponse } from '@square/dashboard-protos/models/squareup/devicesettings/external/device_code_get';
import { camelize, underscore } from '@square/dashboard-utilities/utils/keys';
import { FilterValue } from '@square/dashboard-protos/models/squareup/connect/v2/common/filters';
import { GetBatchDeviceCodesRequest, GetBatchDeviceCodesResponse } from '@square/dashboard-protos/models/squareup/devicesettings/external/device_code_get_batch';
import { DeviceCode } from '@square/dashboard-protos/models/squareup/devicesettings/external/device_code';
import { CreateDeviceCodeRequest, CreateDeviceCodeResponse } from '@square/dashboard-protos/models/squareup/devicesettings/external/device_code_create';
import { DeleteDeviceCodesRequest, DeleteDeviceCodesResponse } from '@square/dashboard-protos/models/squareup/devicesettings/internal/message/delete_device_codes';
import { UpdateDeviceCodeRequest, UpdateDeviceCodeResponse } from '@square/dashboard-protos/models/squareup/devicesettings/internal/message/update_device_code';
import { SendDeviceCodePasswordRequest, SendDeviceCodePasswordResponse } from '@square/dashboard-protos/models/squareup/devicesettings/internal/message/send_device_code_password';
import { ResetDeviceCodeRequest, ResetDeviceCodeResponse } from '@square/dashboard-protos/models/squareup/devicesettings/external/device_code_reset';
import uuid from 'uuid-js';
import { getCsrfToken } from '@square/dashboard-utilities/utils/csrf';
const DEVICE_CODE_BASE_URL = '/2.0/device_codes';
export const SEARCH_DEVICE_CODE_URL = `${DEVICE_CODE_BASE_URL}/search`;
export const GET_BATCH_DEVICE_CODE_URL = `${DEVICE_CODE_BASE_URL}/get_batch`;
export const GET_DEVICE_CODE_URL = `${DEVICE_CODE_BASE_URL}/get`;
export const CREATE_DEVICE_CODE_URL = `${DEVICE_CODE_BASE_URL}/create`;
export const DELETE_DEVICE_CODE_URL = `${DEVICE_CODE_BASE_URL}/delete`;
export const UPDATE_DEVICE_CODE_URL = `${DEVICE_CODE_BASE_URL}/update`;
export const SEND_DEVICE_CODE_PASSWORD_URL = `${DEVICE_CODE_BASE_URL}/send_password`;
export const RESET_DEVICE_CODE_PASSWORD_URL = `${DEVICE_CODE_BASE_URL}/reset`;
var _getCsrfTokenHeader = /*#__PURE__*/new WeakSet();
export default class DeviceCodesService extends Service {
  constructor(...args) {
    super(...args);
    _classPrivateMethodInitSpec(this, _getCsrfTokenHeader);
    _defineProperty(this, "defaultStatus", [DeviceCode.Status[DeviceCode.Status.PAIRED], DeviceCode.Status[DeviceCode.Status.UNPAIRED]]);
  }
  async searchDeviceCodes(products, locations, searchPrefix, sortDirection, limit = 10, cursor, statuses, sortField = SearchDeviceCodesFilter.SortField.DEVICE_CODE_NAME) {
    if (locations?.length === 0 || products?.length === 0) {
      return SearchDeviceCodesResponse.create({
        deviceCodes: []
      });
    }
    const request = SearchDeviceCodesRequest.create({
      limit,
      cursor,
      includePasswords: false,
      query: SearchDeviceCodesQuery.create({
        filter: SearchDeviceCodesFilter.create({
          productTypesFilter: FilterValue.create({
            any: products
          }),
          statusFilter: FilterValue.create({
            any: statuses ?? this.defaultStatus
          }),
          name: searchPrefix,
          locationIds: locations,
          sortField,
          sortDirection
        })
      })
    });
    const json = underscore(request.toJSON());
    const response = await jsonPost(SEARCH_DEVICE_CODE_URL, json, _classPrivateMethodGet(this, _getCsrfTokenHeader, _getCsrfTokenHeader2).call(this));
    return SearchDeviceCodesResponse.fromObject(camelize(response));
  }
  async getBatchDeviceCodes(deviceIds) {
    const request = GetBatchDeviceCodesRequest.create({
      id: deviceIds
    });
    try {
      const response = await jsonPost(GET_BATCH_DEVICE_CODE_URL, request.toJSON(), _classPrivateMethodGet(this, _getCsrfTokenHeader, _getCsrfTokenHeader2).call(this));
      return GetBatchDeviceCodesResponse.fromObject(camelize(response));
    } catch {
      return GetBatchDeviceCodesResponse.create({
        deviceCode: []
      });
    }
  }
  async getDeviceCode(id) {
    const request = GetDeviceCodeRequest.create({
      id
    });
    const json = underscore(request.toJSON());
    const response = await jsonPost(GET_DEVICE_CODE_URL, json);
    return GetDeviceCodeResponse.fromObject(camelize(response)).deviceCode;
  }
  async createDeviceCode(deviceCodeName, productType, locationId) {
    const request = CreateDeviceCodeRequest.create({
      // do this for now while the proto create function doesn't work
      idempotencyKey: uuid.create().toString(),
      deviceCode: DeviceCode.create({
        name: deviceCodeName,
        locationId,
        productType
      })
    });
    const response = await jsonPost(CREATE_DEVICE_CODE_URL, underscore(request.toJSON()), _classPrivateMethodGet(this, _getCsrfTokenHeader, _getCsrfTokenHeader2).call(this));
    return CreateDeviceCodeResponse.fromObject(camelize(response));
  }
  async deleteDeviceCode(deviceCodeId) {
    const request = DeleteDeviceCodesRequest.create({
      deviceCodeIds: [deviceCodeId]
    });
    const response = await jsonPost(DELETE_DEVICE_CODE_URL, underscore(request.toJSON()), _classPrivateMethodGet(this, _getCsrfTokenHeader, _getCsrfTokenHeader2).call(this));
    return DeleteDeviceCodesResponse.fromObject(camelize(response));
  }
  async batchDelete({
    deviceCodeIds
  }) {
    let errors = [];
    for (let index = 0; index < deviceCodeIds.length; index += 100) {
      const payload = deviceCodeIds.slice(index, index + 100);
      const request = DeleteDeviceCodesRequest.create({
        deviceCodeIds: payload
      });
      const response = await jsonPost(DELETE_DEVICE_CODE_URL, underscore(request.toJSON()), _classPrivateMethodGet(this, _getCsrfTokenHeader, _getCsrfTokenHeader2).call(this));
      const transformedResponse = DeleteDeviceCodesResponse.fromObject(camelize(response));
      if (transformedResponse.error) {
        errors = [...errors, ...transformedResponse.error];
      }
    }
    return DeleteDeviceCodesResponse.create({
      error: errors
    });
  }
  async batchReset({
    deviceCodeIds
  }) {
    for (const deviceCodeId of deviceCodeIds) {
      await this.resetDeviceCodePassword(deviceCodeId);
    }
  }
  async updateDeviceCode(deviceCodeId, deviceCodeName) {
    const request = UpdateDeviceCodeRequest.create({
      deviceCodeId,
      name: deviceCodeName
    });
    const response = await jsonPost(UPDATE_DEVICE_CODE_URL, underscore(request.toJSON()), _classPrivateMethodGet(this, _getCsrfTokenHeader, _getCsrfTokenHeader2).call(this));
    return UpdateDeviceCodeResponse.fromObject(camelize(response));
  }
  async sendDeviceCodePassword(deviceCodeId, emailAddress, phoneNumber, template) {
    const request = SendDeviceCodePasswordRequest.create({
      deviceCodeId,
      emailAddress,
      phoneNumber,
      template
    });
    const response = await jsonPost(SEND_DEVICE_CODE_PASSWORD_URL, underscore(request.toJSON()), _classPrivateMethodGet(this, _getCsrfTokenHeader, _getCsrfTokenHeader2).call(this));
    return SendDeviceCodePasswordResponse.fromObject(camelize(response));
  }
  async resetDeviceCodePassword(deviceCodeId) {
    const request = ResetDeviceCodeRequest.create({
      id: deviceCodeId
    });
    const response = await jsonPost(RESET_DEVICE_CODE_PASSWORD_URL, request.toJSON(), _classPrivateMethodGet(this, _getCsrfTokenHeader, _getCsrfTokenHeader2).call(this));
    return ResetDeviceCodeResponse.fromObject(camelize(response));
  }
}
function _getCsrfTokenHeader2() {
  return {
    headers: {
      'X-CSRF-Token': getCsrfToken()
    }
  };
}